import AddAndEditUserPage from "../../../../features/admin/users/add-and-edit-user-page/add-and-edit-user-page";

export default function AddAndEditUser({ isEdit }: { isEdit: boolean }) {
  return <AddAndEditUserPage isEdit={isEdit} />;
}
